import {
  IconButton,
  Menu,
  MenuList,
} from "@mui/material";
import Grid2 from "@mui/material/Unstable_Grid2";
import { Link } from "react-router-dom";
import React, { useMemo, useState } from "react";
import {
  Engineering, FeedOutlined,
  Help,
  Info,
  Mail,
  Menu as MenuIcon,
  MenuBookOutlined,
  MenuOpen,
  QuestionAnswer,
  Search,
  Star,
} from "@mui/icons-material";
import { UserMenu } from "../../features/users/components/user-menu";
import logo3 from "../../assets/logos/logo3.png";
import { MenuLink } from "./menu-item";

export const MobileHeader = () => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const open = useMemo(() => Boolean(anchorEl), [anchorEl]);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <Grid2 container xs={12}>
      <Grid2
        xs={2}
        display={"flex"}
        textAlign="left"
        justifyContent={"left"}
        pl={1}
        pb={1.5}
      >
        <Link to="/">
          <img
            alt={"ELTRP LOGO"}
            src={logo3}
            style={{ width: "min(50px,100%)", marginBottom: "-18px" }}
          />
        </Link>
      </Grid2>
      <Grid2
        xs={10}
        display={"flex"}
        alignItems={"center"}
        justifyContent={"right"}
        pr={1}
      >
        <IconButton
          size={"large"}
          style={{ padding: "0.5rem" }}
          component={Link}
          to={"/search/?query=&from=0&size=10"}
        >
          <Search fontSize={"large"} />
        </IconButton>
        <IconButton
          onClick={handleClick}
          size={"large"}
          style={{ padding: "0.5rem" }}
        >
          {" "}
          {open ? (
            <MenuOpen fontSize={"large"} />
          ) : (
            <MenuIcon fontSize={"large"} />
          )}{" "}
        </IconButton>
        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
        >
          <MenuList sx={{ minWidth: 300 }}>
            <MenuLink text={"How To Search"} to={"/how-to-search"} icon={<Help fontSize={"small"} />} />
            <MenuLink text={"Recently Added Publications"} to={"/recently-added-publications?size=10&from=0"} icon={<FeedOutlined fontSize={"small"} />} />
            <MenuLink text={"Recently Added Projects"} to={"/recently-added-projects?size=10&from=0"} icon={<Engineering fontSize={"small"} />} />
            <MenuLink text={"Newsletter"} to={"/newsletter"} icon={<Mail fontSize={"small"} />} />
            <MenuLink text={"Contact us"} to={"/contact"} icon={<QuestionAnswer fontSize={"small"} />} />
            <MenuLink text={"About"} to={"/about"} icon={<Info fontSize={"small"} />} />
            <MenuLink text={"Dictionary"} to={"/dictionary"} icon={<MenuBookOutlined fontSize={"small"} />} />
            <MenuLink text={"Favourites"} to={"/favourites"} icon={<Star fontSize={"small"} />} />
          </MenuList>
        </Menu>
        <UserMenu fontSize={"large"} />
      </Grid2>
    </Grid2>
  );
};
